// Platform / super-admin auth context. Separate from tenant auth: different
// session storage key, different login route, different JWT.

import { createContext, useContext, useEffect, useState } from 'react';
import { platformApi } from './api.js';

const Ctx = createContext(null);
const TOKEN_KEY = 'm2b_platform_token';
const USER_KEY  = 'm2b_platform_user';

export function PlatformAuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem(USER_KEY) || 'null'); }
    catch { return null; }
  });

  async function login(email, password) {
    const r = await platformApi.login({ email, password });
    sessionStorage.setItem(TOKEN_KEY, r.token);
    sessionStorage.setItem(USER_KEY,  JSON.stringify(r.user));
    setUser(r.user);
    return r;
  }
  function logout() {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(USER_KEY);
    setUser(null);
  }
  // Validate token still works on mount (catches expiry)
  useEffect(() => {
    const t = sessionStorage.getItem(TOKEN_KEY);
    if (!t || !user) return;
    platformApi.me().catch(() => logout());
    // eslint-disable-next-line
  }, []);
  return <Ctx.Provider value={{ user, login, logout }}>{children}</Ctx.Provider>;
}

export const usePlatformAuth = () => useContext(Ctx);
